import { render, staticRenderFns } from "./cash-movements-modal.vue?vue&type=template&id=f5136b6a&scoped=true&"
import script from "./cash-movements-modal.vue?vue&type=script&lang=ts&"
export * from "./cash-movements-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5136b6a",
  null
  
)

export default component.exports